<template>
  <div id="footer" class="footer-box" :class="{ isPosition: isBox }">
    <div class="gpfs-title">{{ $t("gpfs_text") }}</div>
    <div class="gpfs-box">
      <div class="gpfs-cont">
        <div
          class="gpfs-item"
          v-for="(item, index) in qrcodeListData"
          :key="index"
        >
          <img
            v-if="
              item.name == 'tiktok' ||
                item.name == 'red_bok' ||
                item.name == 'red_bok' ||
                item.name == 'official_account' ||
                item.name == 'micro_blog'
            "
            v-lazy="item.value"
            alt=""
          />
          <div class="gpfs-item-text" v-if="item.name == 'tiktok'">
            {{ $t("tiktok") }}
          </div>
          <div class="gpfs-item-text" v-if="item.name == 'red_bok'">
            {{ $t("red_bok") }}
          </div>
          <div class="gpfs-item-text" v-if="item.name == 'official_account'">
            {{ $t("official_account") }}
          </div>
          <div class="gpfs-item-text" v-if="item.name == 'micro_blog'">
            {{ $t("micro_blog") }}
          </div>
        </div>
      </div>
      <div class="tags-btn-css">
        <div class="tags-btn-item" style="margin-top:60px" @click="zshzGO">
          <span>{{ $t("businessCooperation") }}</span
          ><i class="el-icon-arrow-right"></i>
        </div>
        <!-- <div class="tags-btn-item">
          <span>{{ $t("ykxz_text") }}</span
          ><i class="el-icon-arrow-right"></i>
        </div>
        <div class="tags-btn-item">
          <span>{{ $t("complaints_hotline") }}</span
          ><i class="el-icon-arrow-right"></i>
        </div> -->
      </div>
    </div>
    <div class="web-info" @click="href">
      <span v-for="(qrcode, j) in qrcodeListData" :key="j">
        <span class="mr20" v-if="qrcode.name=='web_public_security'||qrcode.name=='web_copyright'||qrcode.name=='web_miitbeian'">{{ qrcode.value }}</span>
      </span>
    </div>
  </div>
</template>
<script>
import { commonQrcode } from "@/api/index";
export default {
  name: "Footer",
  props: {
    isBox: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      qrcodeListData: []
    };
  },
  mounted() {
    this.getCommonQrcodeData();
  },
  methods: {
    href() {
      window.open("https://beian.miit.gov.cn/");
    },
    /*底部二维码*/
    getCommonQrcodeData() {
      commonQrcode().then(res => {
        this.qrcodeListData = res.data;
      });
    },
    zshzGO() {
      this.$router.push({
        path: "/businessCooperation"
      });
    }
  }
};
</script>
<style scoped>
.footer-box {
  width: 100%;
  height: 440px;
  background: rgba(0, 51, 51, 0.7) no-repeat;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  padding: 54px 200px;
}
.isPosition {
  position: relative !important;
  background: #336666 !important;
}
.gpfs-title {
  font-size: 22px;
  color: #ffffff;
  border-bottom: 2px solid #fff;
  padding-bottom: 16px;
}
.gpfs-box {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.gpfs-cont {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 70px;
  flex: 1;
}
.gpfs-item {
  text-align: center;
}
.gpfs-item img {
  width: 152px;
  height: 152px;
}
.gpfs-item .gpfs-item-text {
  font-size: 20px;
  color: #fff;
  margin-top: 40px;
}
.tags-btn-css {
  width: 220px;
  text-align: right;
  color: #fff;
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
.tags-btn-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 193px;
  height: 68px;
  background-color: #00b197;
  margin-bottom: 26px;
  border-radius: 14px;
  font-size: 20px;
}

@media (max-width: 767px) {
  .footer-box {
    padding: 20rem 15rem;
  }
  .gpfs-cont {
    width: 65%;
    flex-wrap: wrap;
    margin-top: 30rem;
  }
  .gpfs-item {
    width: 46%;
    margin-bottom: 10rem;
  }
  .gpfs-item img {
    width: 100rem;
    height: 100rem;
  }
  .gpfs-item .gpfs-item-text {
    margin-top: 10rem;
    font-size: 14rem;
  }
  .tags-btn-css {
    width: 35%;
    margin-top: 30rem;
  }
  .tags-btn-item {
    width: 100%;
    height: 50rem;
    font-size: 14rem;
  }
  .gpfs-title {
    font-size: 18px;
  }
}

.web-info {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  height: 20px;
  width: 100%;
  color: #fff;
  text-align: center;
  font-size: 14px;
}

.mr20 {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue